<app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
<div class="container">
  <div class="row">
    <div class="col-md-12 px-3">
      <h1>{{'HELPDESK' | translate}}</h1>
      <app-search-dealers></app-search-dealers>
    </div>
  </div>
</div>
